import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'HELPDESK/CommonResources/RoutingMenu/routemenu.css';
import HelpdeskApiCall from 'HelpdeskApiCall';
import config from 'config';
import { useDispatch, useSelector } from 'react-redux';

const RouteMenu = (props) => {
    const [activeScreen, setActiveScreen] = useState(props.activeScreen);

    const [navScreens, setNavScreens] = useState([
        {
            name: "Dashboard",
            activeScreen: 'dashboard',
            icon: <FontAwesomeIcon icon={['fas', 'th-large']} size="lg" />,
            isAccessGranted: true
        },
        {
            name: "Onboarding",
            activeScreen: 'productOnboarding',
            icon: <FontAwesomeIcon icon={['fas', 'user-check']} size="lg" />,
            isAccessGranted: true
        },
        {
            name: "Service Request(s)",
            activeScreen: 'query',
            icon: <FontAwesomeIcon icon={['fas', 'comment-dots']} size="lg" />,
            isAccessGranted: true
        },
        {
            name: "Module Training",
            activeScreen: 'demo',
            icon: <FontAwesomeIcon icon={['fas', 'desktop']} size="lg" />,
            isAccessGranted: true
        },
        {
            name: "Co-Ordinators",
            activeScreen: 'coordinator',
            icon: <FontAwesomeIcon icon={['fas', 'users']} size="lg" />,
            isAccessGranted: false
        },
        // {
        //     name: "Onboarding",
        //     activeScreen: 'onboarding',
        //     icon: <FontAwesomeIcon icon={['fas', 'user-check']} size="lg" />,
        //     isAccessGranted: false
        // },
        // {
        //     name: "Service Request Logbook",
        //     activeScreen: 'logbook',
        //     icon: <FontAwesomeIcon icon={['fas', 'list-ul']} size="lg" />,
        //     isAccessGranted: false
        // },
        // {
        //     name: "Module Certification",
        //     activeScreen: 'moduleCertification',
        //     icon: <FontAwesomeIcon icon={['fas','graduation-cap']} size="lg" />,
        //     isAccessGranted: false
        // },
         {
            name: "Earn Rewards",
            activeScreen: 'earnRewards',
            icon: <FontAwesomeIcon icon={['fas','dollar-sign']} size="lg" />,
            isAccessGranted: true
        }
    ]);
    
    //GET TEMPLATE DATA
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    const dispatch = useDispatch();

    useEffect(() => {
        // METHOD CALLED TO GET INSTRUCTOR Service Request(s) COUNT
        apiCallToGetHelpDeskAccess();
    }, []);
    
    // API CALL METHOD TO GET HELP DESK ACCESS
    const apiCallToGetHelpDeskAccess = async () => {
        let requestData = {
            "facultyId": config.faculty_id,
            "iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskAccessDetails',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetHelpDeskAccess();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let accessResponse = jsonResponse.APIResult.access_provided;
                let onboardingAccess = accessResponse?.helpDeskOnboarding?.isAccessGranted == "true" ? true : false;
                let logbookAccess = accessResponse?.helpDeskLogbook?.isAccessGranted == "true" ? true : false;

                let navScreen = navScreens;

                navScreen.map(screen => {
                    if(screen.activeScreen == 'onboarding' && onboardingAccess) {
                        screen.isAccessGranted = true;
                    }

                    if(screen.activeScreen == 'coordinator' && onboardingAccess) {
                        screen.isAccessGranted = true;
                    }

                    if(screen.activeScreen == 'logbook' && logbookAccess) {
                        screen.isAccessGranted = true;
                    }

                    if (screen.activeScreen == 'moduleCertification') {
                        screen.isAccessGranted = true;
                    }
                });

                setNavScreens([ ...navScreen ]);
            }
        }
    }

    // METHOD TO SELECT MENU
    const selectMenu = (menu) => {
        setActiveScreen(menu);

        props.selectMenu(menu);
    }

    return (
        <>
            <div className={routingMenu.expandRouteMenu ? "routingMenuExpanded" : 'routingMenu'}>
                <div className="routing-menu" id="routing-menu" onMouseOver={() => dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: true })} onMouseLeave={() => dispatch({ type: 'TOGGLE_ROUTE_MENU', toggleFlag: false })}>
                    {
                        navScreens.map((menu, index) => {
                            if(routingMenu.expandRouteMenu) {
                                if(menu.isAccessGranted) {
                                    return (
                                        <span className={props.activeScreen == menu.activeScreen ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => selectMenu(menu.activeScreen)}>
                                            <p className="routeMenuIcon">{menu.icon}</p>
                                            <p className="routeMenuName">{menu.name}</p>
                                        </span>
                                    );
                                }
                            }else {
                                if(menu.isAccessGranted) {
                                    return (
                                        <span className={props.activeScreen == menu.activeScreen ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={`Click here to view ${menu.name}`} onClick={() => selectMenu(menu.activeScreen)}>
                                            {menu.icon}
                                        </span>
                                    );
                                }
                            }
                        })
                    }
                    {/* <span className={activeScreen == 'dashboard' ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={'Click here to view dashboard'} onClick={() => selectMenu('dashboard')}>
                        <FontAwesomeIcon icon={['fas', 'th-large']} size="lg" style={{ marginRight: 10 }} />
                        Dashboard
                    </span>
                    <span className={activeScreen == 'query' ? "dropdown-item sideMenu-item  selected" : "dropdown-item sideMenu-item "} title={'Click here to view query'} onClick={() => selectMenu('query')}>
                        <FontAwesomeIcon icon={['fas', 'comment-dots']} size="lg" style={{ marginRight: 10 }} />
                        Service Request(s)
                    </span>
                    <span className={activeScreen == 'demo' ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={'Click here to view online training'} onClick={() => selectMenu('demo')}>
                        <FontAwesomeIcon icon={['fas', 'desktop']} size="lg" style={{ marginRight: 10 }} />
                        Module Training
                    </span>
                    {
                        onboardingAccess &&
                            <span className={activeScreen == 'coordinator' ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={'Click here to view coordinator'} onClick={() => selectMenu('coordinator')}>
                                <FontAwesomeIcon icon={['fas', 'users']} size="lg" style={{ marginRight: 10 }} />
                                Co-Ordinators
                            </span>
                    }
                    {
                        onboardingAccess &&
                            <span className={activeScreen == 'onboarding' ? "dropdown-item sideMenu-item selected" : "dropdown-item sideMenu-item "} title={'Click here to view onboarding'} onClick={() => selectMenu('onboarding')}>
                                <FontAwesomeIcon icon={['fas', 'user-check']} size="lg" style={{ marginRight: 10 }} />
                                Onboarding
                            </span>
                    }
                    {
                        logbookAccess &&
                            <span id = "Logbook" className={activeScreen == 'logbook' ? "dropdown-item sideMenu-item  selected" : "dropdown-item sideMenu-item "} title={'Click here to view Service Request logbook'} onClick={() => selectMenu('logbook')} style={{ display:"flex" }}  >
                                <FontAwesomeIcon icon={['fas', 'list-ul']} size="lg" style={{ marginRight: 10 ,}} />
                                <div>
                                    <div>Service Request </div>
                                    <div> Logbook </div>
                                </div> 
                            </span>
                    } */}
                </div>
            </div>

            <div className="dropdown settingMenu col-md-12" style={{ paddingLeft: 5 }}>
                <p className="menuDropdownButton dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <FontAwesomeIcon icon={['fas', 'bars']} style={{ fontSize: 20 }} />
                </p>
                <div className="dropdown-menu setting-dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {
                            navScreens.map((menu, index) => {
                                return (
                                    <span className={props.activeScreen == menu.activeScreen ? "dropdown-item sideMenu-item-name selected" : "dropdown-item sideMenu-item-name"} title={`Click here to view ${menu.name}`} onClick={() => selectMenu(menu.activeScreen)}>
                                        <p className="routeMenuIcon">{menu.icon}</p>
                                        <p className="routeMenuName">{menu.name}</p>
                                    </span>
                                );
                            })
                        }
                </div>
            </div>
        </>
    );
}

export default RouteMenu;
